import React from "react";
import Analytics, {EVENTS} from "../../../lib/Analytics";

const DeveloperHero = ({ onGetStarted }) => (
  <div className="developer-hero">
    <h1>Plex Search Developer Documentation</h1>
    <p className="developer-hero-subtitle">
      Build powerful biomedical knowledge graph integrations with the Plex REST API and MCP service.
      Query billions of cross-linked relationships across compounds, targets, diseases, pathways, and literature
      &mdash; all from a single endpoint.
    </p>
    <div className="developer-hero-actions">
      <button type="button" className="dev-cta-button" onClick={onGetStarted}>
        Get Started
      </button>
      <a href="/api/ui" className="dev-cta-secondary"
         onClick={() => Analytics.event(EVENTS.DEVELOPER_API_REF_CLICK, {source: "hero"})}>
        API Reference
      </a>
    </div>
  </div>
);

export default DeveloperHero;
